import { motion } from 'framer-motion'
import ReactMarkdown from 'react-markdown'
import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const StatusMessage = ({ content, i }) => {
  const { t } = useLocalization()
  const raw = typeof content === 'string' ? content : content?.message ?? ''
  const text = t(typeof raw === 'string' ? raw : String(raw ?? ''))

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.12, ease: 'easeOut' }}
    >
      <Column className="gap-2" key={i + 'assistant_message'}>
        {text && (
          <Column className="prose prose-sm max-w-none text-gray-500">
            <ReactMarkdown
              components={{
                p: ({ children }) => <p>{children}</p>,
                h2: ({ children }) => <h2>{children}</h2>,
                h3: ({ children }) => <h3>{children}</h3>,
                ul: ({ children }) => <ul>{children}</ul>,
                li: ({ children }) => <li>{children}</li>,
              }}
            >
              {text.replace(/\\n/g, '\n')}
            </ReactMarkdown>
          </Column>
        )}
      </Column>
    </motion.div>
  )
}
